import * as BundleTypes from 'self-service-api/constants/BundleTypes';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import { ENTERPRISE, STARTER } from '../routing/Tabs';
const tabIdToMerchCardLevelMap = {
  [STARTER]: [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL],
  [ENTERPRISE]: [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE]
};
export const getMerchCardsToShow = ({
  tab,
  isFreeToStarter
}) => {
  if (isFreeToStarter) {
    return [ProductLevels.FREE, ProductLevels.STARTER];
  }
  return tab ? tabIdToMerchCardLevelMap[tab] : ProductLevels.currentOrderedPaidProductLevels;
};
export const getMerchCardsToShowForBundle = ({
  bundleType,
  tab
}) => {
  switch (bundleType) {
    case BundleTypes.MARKETING_PLUS_SUITE:
      {
        return [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
      }
    case BundleTypes.CRM_SUITE:
      {
        return tab ? tabIdToMerchCardLevelMap[tab] : ProductLevels.currentOrderedPaidProductLevels;
      }
    case BundleTypes.NONE:
    default:
      {
        return [];
      }
  }
};